import GlobalMixin from '@/app/shared/mixins/global';
import { isNullOrUndefined } from "@config/utils";

export default {
    mixins: [
        GlobalMixin,
    ],
    components: {
        HeaderList: () => import(/* webpackChunkName: "header-list" */ '@/app/shared/components/manage/ManageHeaderList'),
        ColumnActions: () => import(/* webpackChunkName: "column-actions" */ '@/app/shared/components/tables/ColumnActions'),
        ButtonsFooter: () => import(/* webpackChunkName: "buttons-footer" */ '@/app/shared/components/manage/ManageButtonsFooter'),
        TableData: () => import(/* webpackChunkName: "table-data" */ '@/app/shared/components/tables/DataTable'),
    },
    props: {
        moduleCode: {
            type: String,
            require: true,
        },
        panelId: {
            type: String,
            require: true,
        },
        canDetail: {
            type: Boolean,
            default: false,
        },
        canAdd: {
            type: Boolean,
            default: false,
        },
        canEdit: {
            type: Boolean,
            default: false,
        },
        canDelete: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        labelDateFormat: {
            type: String,
            default: 'DD/MM/YYYY',
        },
    },
    data() {
        return {
            form: {
                id: null
            },
            lists: {
                loaded: false,
            },
            icons: {
                mail: 'fas fa-envelope',
                sms: 'fas fa-mobile-screen',
                database: 'fas fa-database',
                default: 'fas fa-message',
            }
        }
    },
    mounted() {
    },
    computed: {
        hasId: function() {
            return !isNullOrUndefined(this.form.id);
        },
        checkActions() {
            return this.canDelete || this.canEdit || this.canDetail;
        },
    },
    methods: {
        getIcon(channel) {
            channel = channel ? channel.toLowerCase() : null;
            let icon = channel in this.icons ? this.icons[channel] : this.icons['default'];
            return `<i class="${icon}"></i>`;
        },
    }
}
